import React from "react";
import Layout from "../../components/Layout/layout";

const KeyDates = () => {
  return (
    <Layout>
      <main className="bg-gray-100 mt-[10vw]">
        <div className="flex absolute md:mt-[-20vw] mt-[-15vw] md:flex-row flex-col items-center w-full justify-center gap-12">
          <div
            className="text-[55px] text-white"
            style={{ fontFamily: "Bebas Neue", textShadow: "2px 1px 0px #000" }}
          >
            Key Dates
          </div>
        </div>
      </main>
      <div className="bg-[#D7DDE1] py-10">
        <div className="w-full md:w-3/4 px-10 md:px-20  py-16 border-2 bg-white  z-20 mb-[-10vh] relative  mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] mb-10">
            IMPORTANT DATES FOR THE CONFERENCE
          </div>

          <div>
            <table className="text-2xl">
              <tr>
                <td className="border-b-2 border-orange-400 border-t-2 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    4<sup>th</sup> October 2023
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 border-t-2 px-8 py-4">
                  Abstract Submission Opens
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    31<sup>st</sup> January 2024
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4 md:pr-48">
                  Abstract Submission Deadline
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    5<sup>th</sup> February to 10<sup>th</sup> March 2024
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  Abstract Acceptance Notification
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    10<sup>th</sup> February to 15<sup>th</sup> June 2024
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  Submission of full length paper
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    15<sup>th</sup> June to 5<sup>th</sup> July 2024
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  Acceptance of full length paper
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    6<sup>th</sup> July to 15<sup>th</sup> July 2024
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  Submission of revised full length paper after review (if
                  required)
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    16<sup>th</sup> July to 25<sup>th</sup> July 2024
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  Final Acceptance of full length camera ready pape
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div className="bg-orange-600 h-[35vh] text-white z-10  "></div>
        {/* <div className="w-3/4 px-20 py-20 border-2  bg-white z-20 mt-[-10vh] relative  mx-auto  ">
          <div className="font-bold text-4xl text-[#1F7E95] mb-10">
            BANK ACCOUNT DETAILS
          </div>

          <div>
            <table className="">
              <tr>
                <td className="border-b-2 border-orange-400 border-t-2 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    BANK NAME
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 border-t-2 px-8 py-4">
                  State Bank of India{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Account Name{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4 md:pr-48">
                  Indian Institute of Technology Guwahati{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Account Number{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  8738 3278 2323{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    IFSC Code{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  SBI0000123{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    Branch Name{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  Sector 15, Assam, Guwahati{" "}
                </td>
              </tr>
              <tr>
                <td className="border-b-2 border-orange-400 py-2">
                  <div className="px-2 py-2 border-r-2 border-orange-400">
                    UPI ID{" "}
                  </div>
                </td>
                <td className="border-b-2 border-orange-400 px-8 py-4">
                  IITG@SBI{" "}
                </td>
              </tr>
            </table>
          </div>
        </div> */}
      </div>
    </Layout>
  );
};

export default KeyDates;
